"use strict";
function closeAllMenus(onlySubMenus = false) {
    const openSubMenus = document.querySelectorAll('.toolbar-dropdown--wrapper.open');
    openSubMenus.forEach((menu) => {
        menu.classList.remove('open');
    });
    if (!onlySubMenus) {
        const mainMenus = document.querySelectorAll('.toolbar-dropdown--open');
        mainMenus.forEach((menu) => {
            menu.classList.remove('toolbar-dropdown--open');
        });
    }
}
function toggleMenu(toggle, event) {
    const header = document.querySelector('header.header');
    const dropdownMenu = document.querySelector('#menu-dropdown');
    const targetMenu = header.querySelector(`#${toggle.getAttribute('data-toggle-menu')}`);
    // If the targeted menu is not already open.
    if (!targetMenu.classList.contains('toolbar-dropdown--open')) {
        closeAllMenus();
        // Toggle the open classes.
        targetMenu.classList.toggle('toolbar-dropdown--open');
    }
    else {
        // If click is outside of the drop-down, close it.
        if (!dropdownMenu.contains(event.target)) {
            closeAllMenus();
        }
        else {
            // Open a sub drop-down after closing all other sub drop-downs.
            closeAllMenus(true);
            event.target.parentNode.classList.toggle('open');
        }
    }
}
document.addEventListener('DOMContentLoaded', () => {
    const menuToggles = document.querySelectorAll('[data-toggle-menu]');
    const mainElement = document.querySelector('main.main');
    // For all menu toggles, attach the opening function.
    menuToggles.forEach((toggle) => {
        toggle.addEventListener('click', event => toggleMenu(toggle, event));
    });
    // When click outside a menu, close all menus.
    mainElement.addEventListener('click', () => closeAllMenus());
});
